<template>
  <div class="profile tw-mb-20">
    <div class="item-a">
      <v-avatar size="140" color="white">

        <img class="img-avatar img-show" v-if="profile.imageProfileUrl && typeof profile.imageProfileUrl !== 'string'"
             :src="profile.imageProfileShow"
             alt="upload">

        <img class="img-avatar" v-else-if="profile.imageProfileUrl && typeof profile.imageProfileUrl === 'string'"
             :srcset="profile.imageProfileUrl + '=c-w320, ' + profile.imageProfileUrl + '=c-w480 1.5x, '+ profile.imageProfileUrl + '=c-w640 2x'"
             :src="profile.imageProfileUrl + '=c-w640'" alt="profile"/>

      </v-avatar>
      <v-file-input
        :class="!profile.imageProfileUrl ? 'icon-upload': 'icon-upload icon-white'"
        label="File input"
        filled
        prepend-icon="mdi-image-plus"
        hide-input
        accept="image/*"
        @change="changeImage"
        :disabled="loading"
      ></v-file-input>
      <v-progress-circular
        v-if="uploadImgState && (updateProfileStatus !== 'success')"
        :rotate="-90"
        :size="140"
        :width="6"
        :value="uploadImgState"
        color="teal"
        class="loading-img"
      >
      </v-progress-circular>
    </div>
    
    <!-- Tab Navigation -->
    <div class="tabs-container">
      <div 
        class="div-tab" 
        :class="{ 'active-tab-container': activeTab === 'personal' }"
        @click="setActiveTab('personal')"
      >
        <div class="active-tab" v-if="activeTab === 'personal'"></div>
        <span class="text-tab">ข้อมูลส่วนตัว</span>
      </div>
      <div 
        class="div-tab" 
        :class="{ 'active-tab-container': activeTab === 'sapb1' }"
        @click="setActiveTab('sapb1')"
      >
        <div class="active-tab" v-if="activeTab === 'sapb1'"></div>
        <span class="text-tab">SAP B1</span>
      </div>
    </div>
    
    <div class="item-b">
      <!-- Personal Information Tab -->
      <v-card height="100%" class="card-detail" v-if="activeTab === 'personal'">
        <v-card-text>
          <h2 class="text-header tw-text-lg tw-font-bold">ข้อมูลส่วนตัว</h2>
          <v-row style="margin-top: 10px">
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameFirstTH"
                  label="ชื่อ"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameLastTH"
                  label="นามสกุล"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameFirstEN"
                  label="Firstname"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameLastEN"
                  label="Lastname"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.companyName"
                  label="บริษัท"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.email"
                  label="อีเมล"
                  outlined
                  :disabled="loading"
                  :error-messages="emailErrorText"
                  @input="clearErrorEmail"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="text-title-password">
                <v-row>
                  <v-col class="text-password">
                    รหัสผ่าน
                  </v-col>
                  <v-col class="text-right">
                    <ResetPassword v-if="!loading"></ResetPassword>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="password"
                  label="พาสเวิร์ด"
                  type="password"
                  outlined
                  disabled
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="updateProfileStatus">
            <v-col class="col-input">
              <div class="div-input">
                <save-alert :status="updateProfileStatus" error-text="ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
                            success-text="บันทึกสำเร็จ" v-if="!loading"></save-alert>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-button">
              <div class="div-button" >
                <v-btn @click="onClickSubmit" color="green darken-1" class="button-submit tw-text-white" :loading="loading"  :disabled="loading">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  บันทึก
                </v-btn>
              </div>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <!-- SAP B1 Tab -->
      <v-card height="100%" class="card-detail" v-if="activeTab === 'sapb1'">
        <v-card-text>
          <h2 class="text-header tw-text-lg tw-font-bold">SAP Business One</h2>
          <p class="tw-text-gray-600 tw-mb-4">ตั้งค่าข้อมูลการเข้าสู่ระบบ SAP Business One สำหรับคุณในบริษัทนี้</p>
          <v-row style="margin-top: 10px">
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="sapB1Settings.username"
                  label="SAP B1 Username"
                  outlined
                  :disabled="loading"
                  placeholder="กรอก Username สำหรับ SAP B1"
                  autocomplete="off"
                  name="sapb1-username"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="sapB1Settings.passwordEncrypt"
                  label="SAP B1 Password"
                  type="password"
                  outlined
                  :disabled="loading"
                  placeholder="กรอก Password สำหรับ SAP B1"
                  autocomplete="new-password"
                  name="sapb1-password"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="sapB1SaveStatus">
            <v-col class="col-input">
              <div class="div-input">
                <save-alert :status="sapB1SaveStatus" error-text="ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
                            success-text="บันทึก SAP B1 สำเร็จ" v-if="!loading"></save-alert>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-button">
              <div class="div-button" >
                <v-btn @click="saveSapB1Settings" color="blue darken-1" class="button-submit tw-text-white" :loading="sapB1Loading"  :disabled="sapB1Loading">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  บันทึก SAP B1
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog v-model="passwordDialog" persistent max-width="600px">
        <template>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <b>กรอกรหัสผ่าน</b>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        
                        name="password"
                        label="รหัสผ่าน"
                        v-model="passwordInputModel"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="clearPassword">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn text color="#6ec39b" type="button" class="submit-email" @click="setPassword">
                  <img
                    src="/images/icons/icon_send_email.svg"
                    style="max-height: 26px; max-width: 26px;"
                    class="mr-2" />
                  <b>ยืนยันรหัสผ่าน</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <!-- SAP B1 Snackbar -->
      <v-snackbar 
        v-model="sapB1Snackbar.show" 
        :color="sapB1Snackbar.color" 
        :timeout="sapB1Snackbar.color === 'error' ? 0 : 4000" 
        top
      >
        {{ sapB1Snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="sapB1Snackbar.show = false">
            ปิด
          </v-btn>
        </template>
      </v-snackbar>

    </div>
  </div>
</template>
<script>

import ResetPassword from '../../../components/admin/profile/reset-password'
import SaveAlert from '../save-alert'
import {mapState} from "vuex";
import { checkImageSmall } from "../../../libs/validateImageUpload";
import loading from '@/store/modules/loading';
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import NodeRSA from 'node-rsa';

const _ = require('lodash');

export default {
  name: "ProfileDetail",
  components: {
    ResetPassword,
    SaveAlert
  },
  computed: mapState({
    userProfile: state => state.user.userProfile,
    uploadImgState : state => state.user.uploadImgState,
    loading: state => state.user.loading,
    updateProfileStatus: state => state.user.updateProfileStatus,
    passwordDialog: state => state.user.passwordDialog,
    passwordInput: state=> state.user.passwordInput,
  }),
  data: function () {
    return {
      activeTab: this.$route.query.tab || 'personal',
      password: "password",
      profile: {...this.userProfile},
      emailErrorText: "",
      passwordInputModel: '',
      showPassword: false,
      sapB1Loading: false,
      sapB1SaveStatus: '',
      sapB1Settings: {
        username: '',
        passwordEncrypt: ''
      },
      originalPassword: '', // เก็บ password เดิมเพื่อเช็คว่าเปลี่ยนหรือไม่
      sapB1Snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },
  mounted() {
    this.getUserProfile();
    // รอให้ user data โหลดเสร็จก่อน
    this.$nextTick(() => {
      this.loadSapB1Settings();
    });
  },
  watch: {
    userProfile: {
      handler: function () {
        this.profile = {...this.userProfile}
        // เมื่อ user profile โหลดเสร็จ ให้โหลด SAP B1 settings
        if (this.userProfile && fc.auth.currentUser?.uid) {
          this.loadSapB1Settings();
        }
      },
    },
    updateProfileStatus: {
      handler: function () {
        if(this.updateProfileStatus === 'success' && !this.loading){
          this.getUserProfile()
          this.$store.dispatch('user/get')
        }
      },
    },
    '$route.query.tab': {
      handler: function (newTab) {
        if (newTab && ['personal', 'sapb1'].includes(newTab)) {
          this.activeTab = newTab;
        }
      },
      immediate: true
    }
  },
  methods:{
    setActiveTab(tab) {
      this.activeTab = tab;
      // Update URL with tab state only if tab is different
      if (this.$route.query.tab !== tab) {
        this.$router.replace({
          query: { 
            ...this.$route.query,
            tab: tab 
          }
        }).catch(err => {
          // Ignore navigation errors for same location
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    loadSapB1Settings() {
      // Load SAP B1 settings for this user in this company
      const userId = fc.auth.currentUser?.uid;
      const companyId = this.$router.currentRoute.params.companyId;
      
      if (userId && companyId) {
        const userPath = `/Users/${userId}/SapB1Settings/${companyId}`;
        const settingDoc = fc.db.doc(userPath);
        
        settingDoc.get().then((snapshot) => {
          if (snapshot.exists) {
            const data = snapshot.data();
            this.sapB1Settings = {
              username: data.username || '',
              passwordEncrypt: data.passwordEncrypt || ''
            };
            // เก็บ password เดิมเพื่อเช็คว่าเปลี่ยนหรือไม่
            this.originalPassword = data.passwordEncrypt || '';
          }
        }).catch((error) => {
          console.error('Error loading SAP B1 settings:', error);
        });
      }
    },
        async saveSapB1Settings() {
      // Save SAP B1 settings for this user in this company
      this.sapB1Loading = true;
      this.sapB1SaveStatus = 'loading';
      
      try {
        // Check if user is authenticated
        const currentUser = fc.auth.currentUser;
        if (!currentUser) {
          this.sapB1SaveStatus = 'error';
          return;
        }
        
        const userId = currentUser.uid;
        const companyId = this.$router.currentRoute.params.companyId;
        
        if (!userId || !companyId) {
          this.sapB1SaveStatus = 'error';
          return;
        }
        
        // Get company API settings to get public key
        const companiesUsersPath = `/CompaniesUsers/${companyId}_${userId}`;
        const apiSettingsDoc = await fc.db.doc(companiesUsersPath).get();
        
        if (!apiSettingsDoc.exists || !apiSettingsDoc.data().publicKey) {
          this.sapB1SaveStatus = 'error';
          this.sapB1Snackbar = {
            show: true,
            message: 'กรุณาตั้งค่า Public Key ในหน้า API Settings ก่อนบันทึก SAP B1',
            color: 'warning'
          };
          return;
        }
        
        const publicKey = apiSettingsDoc.data().publicKey;
        
        // Check if password has been changed
        let encryptedPassword = this.sapB1Settings.passwordEncrypt;
        
        // If password is different from original, encrypt the new password
        if (this.sapB1Settings.passwordEncrypt !== this.originalPassword) {
          encryptedPassword = await this.encryptWithPublicKey(
            this.sapB1Settings.passwordEncrypt, 
            publicKey
          );
        }
        
        const userPath = `/Users/${userId}/SapB1Settings/${companyId}`;
        const data = {
          username: this.sapB1Settings.username,
          passwordEncrypt: encryptedPassword,
          companyId: companyId,
          timeUpdate: firebase.firestore.FieldValue.serverTimestamp()
        };
        
        // Check if document exists to add timeCreate
        const snapshot = await fc.db.doc(userPath).get();
        if (!snapshot.exists) {
          // First time creating - add timeCreate
          data.timeCreate = firebase.firestore.FieldValue.serverTimestamp();
        }
        
        // Save the data
        await fc.db.doc(userPath).set(data, { merge: true });
        
        this.sapB1SaveStatus = 'success';
        this.sapB1Snackbar = {
          show: true,
          message: 'บันทึก SAP B1 settings สำเร็จ',
          color: 'success'
        };
        
      } catch (error) {
        console.log('error', error);
        this.sapB1SaveStatus = 'error';
        
        // Show specific error message for encryption errors
        let errorMessage = 'เกิดข้อผิดพลาดในการบันทึก SAP B1 settings';
        if (error.message && error.message.includes('Public Key') || error.message.includes('Password ยาวเกินไป') || error.message.includes('การเข้ารหัสล้มเหลว')) {
          errorMessage = error.message;
        }
        
        this.sapB1Snackbar = {
          show: true,
          message: errorMessage,
          color: 'error'
        };
      } finally {
        this.sapB1Loading = false;
        // Clear status after 4 seconds
        setTimeout(() => {
          this.sapB1SaveStatus = '';
        }, 4000);
      }
    },
    clearPassword: function() {
      this.$store.dispatch('user/setPasswordUpdateEmail','')
      this.$store.dispatch('setPasswordDialog', false)
    },
    setPassword: function(){
      this.$store.dispatch('user/setPasswordUpdateEmail',  this.passwordInputModel)
      this.$store.dispatch('user/validateCredentialUpdateEmail')
    },
    getUserProfile: function (){
      this.$store.dispatch('user/getUserProfile')
    },
    onClickSubmit: function () {
      let changeEmail = false
      if (!_.isEqual(this.profile['email'], this.userProfile['email']) && this.profile['email'] !== "") {
        changeEmail = true
      }
      this.$store.dispatch('user/setProfileLoadingEmpty')
      this.$store.dispatch('user/updateUser', {profile: this.profile, changeEmail: changeEmail}).then((result) => {
        if (result && result === "email is duplicate") {
          this.emailErrorText = 'อีเมลนี้มีผู้ใช้งานแล้ว'
        }
      })
    },
    changeImage: function (event) {
      if (event) {
        checkImageSmall(event).then((imageSmall) => {
          if (imageSmall) {
            alert("width lower 640 pixels. please select new image.")

          } else {
            let dataSet = _.cloneDeep(this.profile)
            dataSet.imageProfileUrl = event
            dataSet.imageProfileShow = URL.createObjectURL(event)
            this.profile = dataSet
          }
        })
      }
    },
    clearErrorEmail: function (){
      if(this.emailErrorText){
        this.emailErrorText = ""
      }
    },
    
        async encryptWithPublicKey(data, publicKey) {
      try {
        // Validate public key format
        if (!publicKey || typeof publicKey !== 'string') {
          throw new Error('Public Key ไม่ถูกต้อง: ไม่ใช่ string หรือเป็น null');
        }

        if (!publicKey.includes('-----BEGIN PUBLIC KEY-----') || !publicKey.includes('-----END PUBLIC KEY-----')) {
          throw new Error('Public Key ไม่ถูกต้อง: ไม่ใช่รูปแบบ PEM ที่ถูกต้อง (ต้องมี BEGIN และ END headers)');
        }

        // Use node-rsa for encryption (compatible with etax-db)
        const key = new NodeRSA(publicKey);
        key.setOptions({ encryptionScheme: "pkcs1" }); // Must match etax-db settings
        
        // Check data size (RSA has limitations)
        if (data.length > 190) { // RSA-2048 can encrypt max ~190 bytes
          throw new Error('Password ยาวเกินไป: RSA encryption มีข้อจำกัดความยาวข้อมูล');
        }

        // Encrypt the data using node-rsa
        const encryptedData = key.encrypt(data, 'base64');
        
        return encryptedData;
      } catch (error) {
        console.error('Encryption error:', error);
        
        // Provide specific error messages
        if (error.message.includes('Public Key ไม่ถูกต้อง')) {
          throw error; // Re-throw our custom validation errors
        } else if (error.message.includes('Password ยาวเกินไป')) {
          throw error; // Re-throw our custom validation errors
        } else {
          throw new Error(`การเข้ารหัสล้มเหลว: ${error.message}`);
        }
      }
    },
    

    
    
  },
}
</script>

<style lang="scss">
.profile {
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
}
.item-a {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-b {
  flex: 6;
}
.div-input{
  width: 40%;
}
.col-input{
  display: flex;
}
.img-avatar {
  border: 4px solid white;
}
//.input-profile .v-text-field__details {
//  display: none !important;
//}
.col-button{
  display: flex;
  flex-direction: row;
}
.div-button{
  width: 40%;
}
.button-submit{
  float: right;
}
.v-text-field fieldset{
  border-radius: 10px;
}
.text-header{
  padding-top: 1rem;
  padding-bottom: 0.25rem;
}
.text-title-password{
  width: 40%;
}
.img-edit{
  text-align: right;
}
.text-button-edit{
  font-size: 18px !important;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.6) !important;
  letter-spacing: unset !important;
}
.card-detail{
  padding-left: 24px;
}
.text-password{
  font-size: 1.5em!important;
  font-weight: bold !important;
  display: flex;
  align-items: center;
}

// Tab Styles
.tabs-container {
  display: flex;
  gap: 10px;
  margin: 0 0 -5px 16px;
}

.div-tab{
  width: 160px;
  height: 52px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 80px 10px 10px;
  background-color: white;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.active-tab-container {
  background-color: #f0f8ff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.text-tab{
  color: #c9242b;
  font-size: 20px;
}
.active-tab{
  width: 4px;
  height: 32px;
  background-color: #c9242b;
  position: absolute;
  left: 16px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.icon-upload{
  position: absolute;
  top: 123px;
}
.icon-white .v-icon {
  //color: white;
  filter: invert(1);
  mix-blend-mode: difference;
}
.v-application--is-ltr .v-input__prepend-outer{
  margin-right: unset !important;
  margin-top: unset !important;
}
.loading-img{
  position: absolute !important;
}
.img-show{
  object-fit: cover;
}
@media all and (max-width: 800px) and (min-width: 701px){
  .div-input, .div-button, .text-title-password{
    width: 60%;
  }
  .card-detail{
    padding-left: unset;
  }
  .tabs-container {
    flex-direction: column;
    gap: 5px;
  }
  .div-tab {
    width: 140px;
  }
}

@media all and (max-width: 700px) {
  .div-input, .div-button, .text-title-password{
    width: 100%;
  }
  .card-detail{
    padding-left: unset;
  }
  .tabs-container {
    flex-direction: column;
    gap: 5px;
  }
  .div-tab {
    width: 120px;
  }
}
</style>
